<template>
  <b-card class="mb-0 mt-1 pb-1" v-if="!isWidthMobile">
    <el-select
      size="mini"
      filterable
      v-model="currentDate">
      <el-option v-for="(option, index) in items"
                 class="select-default"
                 :value="option"
                 :label="option"
                 :key="index">
      </el-option>
    </el-select>
    <div class="btn-group ml-2">
      <button v-b-tooltip.hover type="button" class="btn btn-link fa fa-arrow-left fa-lg" aria-hidden="true"  @click="goPrev()" ></button>
      <button v-b-tooltip.hover type="button" class="btn btn-link fa fa-arrow-right fa-lg"  aria-hidden="true"  @click="goNext()" ></button>
    </div>
  </b-card>
</template>

<script>

import { getUserRoles } from '@/utils/checkRoles'

export default {
  name: 'DatePicker',
  data () {
    return {
      items: [],
      currentDate: this.$moment(this.$route.params.date).format('YYYY-MM-DD')
    }
  },
  computed: {
    isWidthMobile () {
      return false
    },
    idServiceman () {
      return getUserRoles().id_userdata
    }
    // currentDate () {
    //   return this.$moment(this.$route.params.date)
    // }
  },
  watch: {
    'currentDate' () {
      this.$router.push({ name: 'DailyPlanShow', params: { idServiceman: this.idServiceman, date: this.currentDate } })
    }
  },
  created () {
    this.createDatesOptions()
  },
  methods: {
    createDatesOptions () {
      let date = this.$moment(this.currentDate).subtract(10, 'days')
      for (let i = 0; i < 20; i++) {
        this.items.push(this.$moment(date).add(i, 'days').format('YYYY-MM-DD'))
      }
    },
    goPrev () {
      this.currentDate = this.$moment(this.currentDate).subtract(1, 'days').format('YYYY-MM-DD')
    },
    goNext () {
      this.currentDate = this.$moment(this.currentDate).add(1, 'days').format('YYYY-MM-DD')
    }
  }
}
</script>
